<template>
    <v-text-field v-model="percentage" :rules="rules" :label="label" @input="onInput" type="number" :required="required" :dense="dense" :readonly="readonly" :disabled="disabled" />
</template>

<script>


    export default {
        props: [
            'label',
            'value',
            'required',
            'dense',
            'disabled',
            'readonly'
        ],

        data() {
            return {
                percentage: null,
                rules: [
                    v => v >= 0 || 'Percentage cannot be negative',
                    v => v <= 100 || 'Percentage cannot be greater than 100',
                ],
            };
        },

        methods: {
            onInput() {
                if (typeof (this.percentage) !== "undefined" && this.percentage !== null && this.percentage !== "") {
                    var output = Math.round(this.percentage / 100.0 * 1000) / 1000;
                    this.$emit('input', output);
                }

            }
        },

        watch: {
            value: {
                immediate: true,
                handler(value) {
                    if (typeof value === 'undefined' || value === null) {
                        this.percentage = null;
                    }
                    else {
                        this.percentage = this.value * 100;
                    }
                }
            }
        }
    };
</script>
